// ----------------------------------------------------------------------------
// Component: Info Panel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_info-panel.scss';